import axios from "axios";

const apiUrl = process.env.VUE_APP_API_URL;


export const getAddresses = async () => {
    try {
        const response = await axios.get(`${apiUrl}/user/get-address`);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
};
export const SetDefaultAddress = async (id) => {
    try {
        const response = await axios.post(`${apiUrl}/user/set-default-address`,{'address_id':id});
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message
        };
    }
};
export const removeAddress = async (id) => {
    try {
        const response = await axios.delete(`${apiUrl}/user/address/${id}/delete`);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message
        };
    }
};

export const createAddress = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/user/address/create`, data);
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message
        };
    }
};

export const updateAddress = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrl}/user/address/update/${id}`, data);
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message
        };
    }
};